import React from "react";

const About = () => {
  return (
    <>
      <div style={{ width: "80vw", margin: "auto" }}>
        <h1 style={{ textAlign: "center", color: "white", margin: "10px 0px" }}>
          About us
        </h1>
        <h4 style={{color: "white"}}>This is a simple todoslist website made using MERN stack with OTP sign-up and
        forgot password functionality. This is just a educational project.
        Please do not store any vital information in this.</h4>
      </div>
    </>
  );
};

export default About;
